import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRemoveCross = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 23",
	height: 23,
	width: 24,
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			style: {
				fill: "#ffffff",
				stroke: "#bebebe",
				strokeWidth: 1
			},
			children: [/* @__PURE__ */ _jsx("ellipse", {
				cx: 12,
				cy: 11.5,
				rx: 12,
				ry: 11.5,
				style: { stroke: "none" }
			}), /* @__PURE__ */ _jsx("ellipse", {
				cx: 12,
				cy: 11.5,
				rx: 11.5,
				ry: 11,
				style: { fill: "none" }
			})]
		}),
		/* @__PURE__ */ _jsx("line", {
			x2: 15.889088,
			x1: 8.1109123,
			y1: 15.389088,
			y2: 7.6109128,
			style: {
				fill: "none",
				stroke: "#880303",
				strokeWidth: 1,
				strokeOpacity: 1
			}
		}),
		/* @__PURE__ */ _jsx("line", {
			x2: 15.889088,
			x1: 8.1109123,
			y1: 7.6109128,
			y2: 15.389088,
			style: {
				fill: "none",
				stroke: "#880303",
				strokeWidth: 1,
				strokeOpacity: 1
			}
		})
	]
});
export default SvgRemoveCross;
